<template>
  <footer class="footer">
    <div class="footer-glow" aria-hidden="true"></div>
    <div class="container">
      <div class="footer-grid">
        <!-- 品牌 -->
        <div class="f-brand">
          <router-link to="/home" class="f-logo">
            <span class="f-word">BAIZE</span>
          </router-link>
          <p class="f-slogan">
            以算法为引擎，深耕人工智能软件、智能机器人、集成电路设计与数字创意，让智能计算触达千行百业。
          </p>
          <ul class="f-scope">
            <li v-for="s in scope" :key="s">{{ s }}</li>
          </ul>
        </div>

        <!-- 快捷导航 -->
        <div class="f-col">
          <h4>快速导航</h4>
          <ul>
            <li v-for="m in menus" :key="m.label">
              <router-link :to="m.path">{{ m.label }}</router-link>
            </li>
          </ul>
        </div>

        <!-- 联系方式 -->
        <div class="f-col f-contact">
          <h4>联系我们</h4>
          <ul>
            <li>
              <span class="ic">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z"
                    stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" />
                </svg>
              </span>
              <span>咨询热线：18151253971</span>
            </li>
            <li>
              <span class="ic">
                <svg viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.7" />
                  <path d="m3 7 9 6 9-6" stroke="currentColor" stroke-width="1.7" />
                </svg>
              </span>
              <span>boost@lygbzai.com</span>
            </li>
            <li>
              <span class="ic">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11Z" stroke="currentColor"
                    stroke-width="1.7" />
                  <circle cx="12" cy="10" r="2.6" stroke="currentColor" stroke-width="1.7" />
                </svg>
              </span>
              <span>江苏省连云港市海州区新海街道新孔南路46号304室</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="f-bottom">
        <p class="f-copy">
          <span>© {{ year }} 连云港白泽数字科技有限公司　版权所有</span>
          <a class="f-icp" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">苏ICP备2026068249号-1</a>
        </p>
        <!-- <div class="f-social">
          <span v-for="s in socials" :key="s.name" class="f-social-item" :aria-label="s.name" :title="s.name">
            <svg v-if="s.name === '微信'" viewBox="0 0 24 24" fill="none">
              <path d="M4.4 13.6 L2.6 17.8 L6.9 15.6 Z" fill="currentColor" />
              <circle cx="9" cy="9.5" r="6.5" fill="currentColor" />
              <circle cx="6.8" cy="8.3" r="1.1" fill="#fff" />
              <circle cx="11.2" cy="8.3" r="1.1" fill="#fff" />
              <path d="M19.7 18.2 L21.4 21.5 L17.4 20 Z" fill="currentColor" />
              <circle cx="16" cy="15" r="5.2" fill="currentColor" stroke="#fff" stroke-width="1.3" />
              <circle cx="14.3" cy="13.9" r="0.95" fill="#fff" />
              <circle cx="17.7" cy="13.9" r="0.95" fill="#fff" />
            </svg>
            <svg v-else-if="s.name === '公众号'" viewBox="0 0 24 24" fill="none">
              <path d="M6 3H18a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H11L6 21V17a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Z"
                stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              <circle cx="12" cy="8.5" r="1.8" stroke="currentColor" stroke-width="1.5" />
              <path d="M8.6 13.4a3.6 3.6 0 0 1 6.8 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <svg v-else viewBox="0 0 24 24" fill="none">
              <circle cx="5" cy="12" r="1.9" fill="currentColor" />
              <circle cx="12" cy="12" r="1.9" fill="currentColor" />
              <circle cx="19" cy="12" r="1.9" fill="currentColor" />
            </svg>
            <span class="f-social-qr">
              <img :src="qrImage" :alt="s.name + '二维码'" />
            </span>
          </span>
        </div> -->
      </div>
    </div>
  </footer>
</template>

<script setup>
import qrImage from '@/assets/1.jpg'

const menus = [
  { label: '首页', path: '/home' },
  { label: 'APP下载', path: '/download' },
  { label: '发展路径', path: '/path' },
  { label: '联合开发', path: '/coop' },
  { label: '小伙伴们', path: '/team' }
]
const scope = [
  'AI理论与算法软件开发', 'AI应用软件开发', 'AI机器人', '集成电路设计',
  '数字创意产品 · 数字内容制作', '技术服务 · 开发 · 咨询 · 交流 · 转让 · 推广'
]
const socials = [{ name: '微信' }, { name: '公众号' }, { name: '更多' }]
const year = new Date().getFullYear()
</script>

<style scoped>
.footer {
  position: relative;
  margin-top: 0;
  padding: 72px 0 0;
  background: linear-gradient(180deg, transparent, rgba(237, 244, 254, 0.95) 24%);
  border-top: 1px solid var(--c-line);
  /* 用 clip 而非 hidden：clip 不创建滚动容器，避免页脚内元素被聚焦/滚动顶起后整体上移、
     二维码弹层被裁切 */
  overflow: clip;
}

.footer-glow {
  position: absolute;
  left: 50%;
  bottom: -160px;
  width: 720px;
  height: 320px;
  transform: translateX(-50%);
  background: radial-gradient(closest-side, rgba(11, 158, 216, 0.1), transparent);
  filter: blur(20px);
  pointer-events: none;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1.8fr 1fr 1.3fr;
  gap: 56px;
  padding-bottom: 52px;
}

.f-logo {
  display: inline-flex;
  align-items: center;
}

.f-word {
  display: inline-block;
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 8px;
  text-indent: 8px;
  color: #000;
  transition: opacity 0.25s ease;
}

.f-logo:hover .f-word {
  opacity: 0.82;
}

.f-slogan {
  margin: 18px 0;
  color: var(--c-sub);
  font-size: 14.5px;
  line-height: 2;
}

.f-scope {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.f-scope li {
  font-size: 12px;
  color: var(--c-dim);
  border: 1px solid var(--c-line);
  padding: 4px 10px;
  border-radius: 999px;
}

.f-col h4 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 18px;
  position: relative;
  padding-bottom: 10px;
}

.f-col h4::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 26px;
  height: 2px;
  background: var(--grad-main);
  border-radius: 2px;
}

.f-col ul {
  display: flex;
  flex-direction: column;
  gap: 11px;
}

.f-col li {
  font-size: 14.5px;
  color: var(--c-sub);
}

.f-col a:hover {
  color: var(--brand2);
}

.f-contact li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  /* 行高与图标等高，保证地址换行时图标对齐首行，三项间距保持一致 */
  line-height: 30px;
  color: var(--c-dim);
}

.f-contact .ic {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  border: 1px solid var(--c-line);
  color: var(--brand2);
  background: rgba(34, 211, 253, 0.06);
}

.f-contact .ic svg {
  width: 16px;
  height: 16px;
}

.f-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
  padding: 22px 0;
  border-top: 1px solid var(--c-line);
  font-size: 13px;
  color: var(--c-dim);
}

.f-icp {
  display: inline-block;
  margin-left: 14px;
  color: var(--c-dim);
  transition: color 0.25s ease;
}

.f-icp:hover {
  color: var(--brand2);
}

.f-social {
  display: flex;
  gap: 10px;
}

.f-social-item {
  position: relative;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid var(--c-line);
  color: var(--c-sub);
  transition: 0.25s ease;
  cursor: pointer;
}

.f-social-item:hover {
  color: var(--brand2);
  border-color: rgba(34, 211, 253, 0.5);
  transform: translateY(-2px);
}

.f-social svg {
  width: 17px;
  height: 17px;
}

/* hover 弹出的二维码 */
.f-social-qr {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 10px);
  /* 绝对定位元素默认可用宽度受父级 34px 限制，需用 max-content 撑开 */
  width: max-content;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--c-line);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(11, 40, 80, 0.14);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateX(-50%) translateY(6px);
  transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s;
  z-index: 5;
}

.f-social-qr::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 100%;
  width: 10px;
  height: 10px;
  margin-top: -6px;
  background: #fff;
  border-right: 1px solid var(--c-line);
  border-bottom: 1px solid var(--c-line);
  transform: translateX(-50%) rotate(45deg);
}

.f-social-qr img {
  display: block;
  width: 160px;
  height: auto;
  border-radius: 8px;
}

.f-social-item:hover .f-social-qr {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

/* 最后一个图标改为右对齐弹出，避免弹层超出页脚右边界、把页脚撑出横向滚动 */
.f-social-item:last-child .f-social-qr {
  left: auto;
  right: 0;
  transform: translateY(6px);
}

.f-social-item:last-child .f-social-qr::after {
  left: auto;
  right: 12px;
  transform: rotate(45deg);
}

.f-social-item:last-child:hover .f-social-qr {
  transform: translateY(0);
}

@media (max-width: 980px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 34px;
  }
}

@media (max-width: 600px) {
  .footer {
    padding-top: 48px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .f-bottom {
    justify-content: center;
    text-align: center;
  }
}
</style>
